import { memo, useCallback } from 'react';
import styled from 'styled-components';

import { StyleLabel } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/ComponentEditorStyleSections/inputs/StyleInput';
import Select, { Option } from 'design-system/components/Select';

const SelectStyleContainer = styled.div`
  position: relative;
  // Note(Evan) - This might need to be applied to the core Select component:
  // Fixes the small half-pixel gap above the select button when the component is rendered
  & > button {
    display: flex;
    justify-content: space-between;
  }
`;

type SelectStyleInputProps = {
  name: string;
  field: string;
  label?: string;
  onChange: (value: string, field: string) => void;
  placeholder: string;
  defaultValue?: string;
  editable: boolean;
  options: { label: string; value: string }[] | { label: JSX.Element; value: string }[];
};

const SelectStyleInput = ({
  name,
  label,
  defaultValue,
  editable,
  field,
  onChange,
  options,
  placeholder,
}: SelectStyleInputProps) => {
  const handleChange = useCallback(
    (value: string) => {
      onChange(value, field);
    },
    [onChange, field],
  );

  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  const hasSetValue = ![null, ''].includes(defaultValue);

  return (
    <SelectStyleContainer>
      {label && <StyleLabel htmlFor={name}>{label}</StyleLabel>}
      <Select
        size='sm'
        onValueChange={handleChange}
        id={name}
        disabled={!editable}
        placeholder={placeholder}
        {...(hasSetValue && {
          value: defaultValue,
        })}
      >
        {options.map(({ label, value }) => (
          <Option key={`${field}-${label}-${value}`} value={value}>
            {label}
          </Option>
        ))}
      </Select>
    </SelectStyleContainer>
  );
};

export default memo(SelectStyleInput);
